import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  IOSDubaiTechIcon,
  IOSDubaiTechLangIcon,
  IOSDubaiTechTestIcon,
  IOSDubaiTechDataIcon,
} from "../../../app-constants";
import { Link } from "gatsby";

const StackItem = [
  {
    icon: IOSDubaiTechLangIcon,
    title: "Programming Languages",
    description: "Swift, Objective-C, JavaScript",
  },
  {
    icon: IOSDubaiTechIcon,
    title: "Technologies",
    description: "iOS SDK, iOS Native Dev Kit",
  },
  {
    icon: IOSDubaiTechDataIcon,
    title: "Databases",
    description: "SQLite, Core Data",
  },
  {
    icon: IOSDubaiTechTestIcon,
    title: "Testing",
    description: "Simulator, Testlabs",
  },
];

function Technology(props) {
  return (
    <div className="technoloy_sec p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="">
            <div className="example" data-text="Tech">
              <h2>
                Technologies We Use for Custom iOS App Development Services
              </h2>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1"
          >
            <p>
              As one of the leading{" "}
              <Link to="https://www.tekrevol.com/mobile-app-development-company-dubai">
                mobile app development companies in Dubai
              </Link>
              , we utilize a diverse array of powerful technologies customized
              to your precise requirements.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={11} xxl={11} className="m-auto">
            <div className="technology_main">
              {StackItem.map((item, index) => (
                <div className="technology_item">
                  <div className="svg_icon">{item.icon}</div>
                  <h6>{item.title}</h6>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Technology;
